import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceSelector from '../components/ServiceSelector';
import BookingSummary from '../components/BookingSummary';

const timeslots = ['08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00'];

export default function Booking(){
  const navigate = useNavigate();
  const [form, setForm] = useState({
    serviceId: 'basic',
    extras: [],
    mobileOrDropoff: 'dropoff',
    vehicle: { year: '', make: '', model: '' },
    address: { street: '', city: '', zip: '' },
    date: '',
    time: '',
    contact: { name: '', email: '', phone: '' },
    notes: '',
  });

  const set = (patch) => setForm(prev => ({ ...prev, ...patch }));
  const [available, setAvailable] = useState({});
  const [loadingSlots, setLoadingSlots] = useState(false);

  const fetchAvailability = async (date) => {
    if(!date) return;
    setLoadingSlots(true);
    try{
      const res = await fetch('http://localhost:4242/api/availability?date=' + date);
      const data = await res.json();
      setAvailable(prev => ({ ...prev, [date]: data.times }));
    }catch(e){ console.error(e); }
    setLoadingSlots(false);
  };

  const proceed = () => {
    if(!form.date || !form.time || !form.contact.email){
      alert('Please select a date/time and enter your email.');
      return;
    }
    sessionStorage.setItem('booking', JSON.stringify(form));
    navigate('/checkout');
  };

  return (
    <div className="container narrow">
      <h1>Book Your Detailing</h1>
      <p className="muted">Choose your package, pick a time, and pay a deposit or in full.</p>

      <ServiceSelector value={form} onChange={(v)=>set(v)} />

      <div className="grid two" style={{ marginTop: 24 }}>
        <div className="card">
          <h3>Appointment</h3>

          <div className="grid two">
            <label>Service Type
              <select value={form.mobileOrDropoff} onChange={e=>set({ mobileOrDropoff: e.target.value })}>
                <option value="dropoff">Shop drop-off</option>
                <option value="mobile">Mobile service (we come to you)</option>
              </select>
            </label>
            <label>Date
              <input type="date" value={form.date} onChange={e=>{ set({ date: e.target.value, time: '' }); fetchAvailability(e.target.value); }} />
            </label>
          </div>

          {form.mobileOrDropoff === 'mobile' && (
            <div>
              <h3 style={{ marginTop: 16 }}>Address (for mobile)</h3>
              <div className="grid three">
                <label>Street<input type="text" value={form.address.street} onChange={e=>set({ address: { ...form.address, street: e.target.value }})} placeholder="123 Main St" /></label>
                <label>City<input type="text" value={form.address.city} onChange={e=>set({ address: { ...form.address, city: e.target.value }})} placeholder="Your City" /></label>
                <label>ZIP<input type="text" value={form.address.zip} onChange={e=>set({ address: { ...form.address, zip: e.target.value }})} placeholder="12345" /></label>
              </div>
            </div>
          )}

          <div className="grid two">
            <label>Time
              <select value={form.time} onChange={e=>set({ time: e.target.value })}>
                <option value="">{loadingSlots ? 'Loading…' : 'Select a time'}</option>
                {(available[form.date] || timeslots).map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </label>
          </div>

          <h3 style={{ marginTop: 16 }}>Contact</h3>
          <div className="grid three">
            <label>Name<input type="text" value={form.contact.name} onChange={e=>set({ contact: { ...form.contact, name: e.target.value }})} placeholder="Jane Doe" /></label>
            <label>Email<input type="email" value={form.contact.email} onChange={e=>set({ contact: { ...form.contact, email: e.target.value }})} placeholder="you@email.com" /></label>
            <label>Phone<input type="tel" value={form.contact.phone} onChange={e=>set({ contact: { ...form.contact, phone: e.target.value }})} placeholder="(555) 123-4567" /></label>
          </div>

          <label>Notes (optional)
            <textarea rows="3" value={form.notes} onChange={e=>set({ notes: e.target.value })} placeholder="Anything we should know? (e.g., pet hair, kid seats)"></textarea>
          </label>
        </div>

        <div className="card">
          <BookingSummary data={form} />
          <p className="muted">Estimated time: {form.serviceId === 'premium' ? '3–4 hrs' : form.serviceId === 'deluxe' ? '2–3 hrs' : '1–2 hrs'}{form.mobileOrDropoff==='mobile' ? ' + travel' : ''}</p>
          <button className="btn primary" onClick={proceed} style={{ width: '100%', marginTop: 12 }}>Continue to Payment</button>
          <p className="muted small">You won't be charged yet.</p>
        </div>
      </div>
    </div>
  );
}
